module.exports = __webpack_public_path__ + "img/winner3.9b73060c.png";